import { createQueryKeys } from "@lukemorales/query-key-factory";

/**
 * Keys used to invalidate stored cached data regarding excise warehouse module
 */
export const exciseWarehouseKeys = createQueryKeys("excise_warehouses", {
  exciseWarehouseList: () => ({
    queryKey: ["excise_warehouse_list"],
  }),
});
